import Parser from 'html-react-parser';
import * as Constants from '@global/App/constants/constants';
import { useAEMResource } from '@global/hooks/useAEMResource';
import { AEM_HEADER_HEIGHT } from '@global/App/constants/constants';

// CSS and assets
import '@global/components/Header/style.scss';
import { SubscritpionDetailsHeader } from '@src/global/components/Header/components/SubscritpionDetailsHeader';
import { SiteConfig } from '@src/global/utils/SiteConfig';

export const Header: React.FC = () => {
  const { stylesLoaded, header } = useAEMResource();
  const { isSpectraBase } = SiteConfig.getConfig();
  const currentPage = window.location.href;

  if (
    currentPage.includes(Constants.Pages.SUBSCRIPTION_DETAILS) &&
    !isSpectraBase
  )
    return <SubscritpionDetailsHeader />;

  if (!stylesLoaded || !header)
    return <div style={{ height: `${AEM_HEADER_HEIGHT}px` }}></div>;
  return <>{Parser(header)}</>;
};
